import { cn } from "@/lib/cn";

export function Logo({
  size = 28,
  withWordmark = false,
  tone = "dark",
  className,
}: {
  size?: number;
  withWordmark?: boolean;
  /** "dark" wordmark for light backgrounds, "light" for the dark sidebar. */
  tone?: "dark" | "light";
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <img
        src="/logo-mark.png"
        alt=""
        width={size}
        height={size}
        className="shrink-0 rounded-md"
        aria-hidden
      />
      {withWordmark ? (
        <span
          className={cn(
            "font-bold text-[15px] tracking-tight",
            tone === "light"
              ? "text-white"
              : "text-[var(--color-teal-700)]",
          )}
        >
          DYUTHI{" "}
          <span className="text-[var(--color-gold-text)]">Billing</span>
        </span>
      ) : null}
    </span>
  );
}
